import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { CircularProgressProps } from "@/types";
export function CircularProgress(t0) {
  const $ = _c(43);
  const {
    progress,
    size: t1
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const radius = (size - 1.5) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  let t2;
  if ($[0] !== progress) {
    t2 = () => {
      if (progress === 100) {
        return "text-green-500";
      }
      if (progress > 0) {
        return "text-blue-500";
      }
      return "text-muted-foreground";
    };
    $[0] = progress;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getProgressColor = t2;
  let t3;
  if ($[2] !== progress) {
    t3 = () => {
      if (progress === 100) {
        return "#22c55e";
      }
      if (progress > 0) {
        return "#3b82f6";
      }
      return "#a1a1aa";
    };
    $[2] = progress;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getColorValue = t3;
  let t4;
  if ($[4] !== progress) {
    t4 = () => {
      if (progress === 100) {
        return "\uD83C\uDF89";
      }
      if (progress >= 75) {
        return "\uD83D\uDE80";
      }
      if (progress >= 50) {
        return "\uD83D\uDCAA";
      }
      if (progress >= 25) {
        return "\uD83D\uDC4A";
      }
      if (progress > 0) {
        return "\uD83D\uDCAB";
      }
      return "\uD83C\uDFAF";
    };
    $[4] = progress;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getEmoji = t4;
  let t5;
  if ($[6] !== progress) {
    t5 = <div className="text-xs font-medium text-muted-foreground">{progress}%</div>;
    $[6] = progress;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== size) {
    t6 = {
      width: size,
      height: size
    };
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("absolute inset-0 rounded-full", "transition-all duration-200 ease-out");
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = `conic-gradient(${getColorValue()} ${progress}%, transparent ${progress}%)`;
  const t9 = progress > 0 ? 0.25 : 0;
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <div className={t7} style={{
      background: t8,
      opacity: t9
    }} />;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = `0 0 ${size} ${size}`;
  const t12 = size / 2;
  const t13 = size / 2;
  let t14;
  if ($[14] !== radius || $[15] !== t12 || $[16] !== t13) {
    t14 = <circle className="text-muted-foreground/15" strokeWidth={1.5} stroke="currentColor" fill="none" r={radius} cx={t12} cy={t13} />;
    $[14] = radius;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== getProgressColor) {
    t15 = cn(getProgressColor(), "transition-all duration-200 ease-out");
    $[18] = getProgressColor;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  const t16 = size / 2;
  const t17 = size / 2;
  const t18 = `rotate(-90 ${size / 2} ${size / 2})`;
  let t19;
  if ($[20] !== circumference || $[21] !== radius || $[22] !== strokeDashoffset || $[23] !== t15 || $[24] !== t16 || $[25] !== t17 || $[26] !== t18) {
    t19 = <circle className={t15} strokeWidth={1.5} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" stroke="currentColor" fill="none" r={radius} cx={t16} cy={t17} transform={t18} />;
    $[20] = circumference;
    $[21] = radius;
    $[22] = strokeDashoffset;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== size || $[29] !== t11 || $[30] !== t14 || $[31] !== t19) {
    t20 = <svg width={size} height={size} viewBox={t11}>{t14}{t19}</svg>;
    $[28] = size;
    $[29] = t11;
    $[30] = t14;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t10 || $[34] !== t20 || $[35] !== t6) {
    t21 = <div className="relative" style={t6}>{t10}{t20}</div>;
    $[33] = t10;
    $[34] = t20;
    $[35] = t6;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  const t22 = getEmoji();
  let t23;
  if ($[37] !== t22) {
    t23 = <div className="text-sm">{t22}</div>;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== t21 || $[40] !== t23 || $[41] !== t5) {
    t24 = <div className="flex items-center gap-2">{t5}{t21}{t23}</div>;
    $[39] = t21;
    $[40] = t23;
    $[41] = t5;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  return t24;
}